import { UserTrackingFlow, } from "@/types/ApplyFlowParameters";
import { createContext } from "react";
export var GlobalContext = createContext({
    properties: {
        name: "Default",
        logo: {
            id: "default",
            alt: "default",
            imageUrl: "some_default.png",
            href: "some_default.png",
        },
        links: [],
        modules: {
            topBanner: true,
            header: true,
            footer: true,
            remoteOnlyToggle: true,
            countryDropdown: true,
            companyFilter: true,
            occupationsFilter: true,
            datePostedFilter: false,
        },
    },
    countryConfig: {
        selectedCountry: "US",
        supportedCountries: ["US"],
    },
    applyFlowParameters: {
        userTrackingFlow: UserTrackingFlow.OFFCAP,
    },
});
